import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// Intake forms (Report, Feedback) are reached from another page and should hand
// the user back to it — both from the close button and after submitting.
//
// The originating path arrives in router state (set by whatever linked here).
// Falling back to the hub keeps the button useful on a direct visit or refresh,
// where there is no history entry to return to.
export default function useReturnTo(fallback = '/dashboard/fraud-alerts') {
  const location = useLocation();
  const navigate = useNavigate();
  const target = location.state?.from || fallback;

  const goBack = useCallback(() => navigate(target), [navigate, target]);

  return { target, goBack };
}
